module.exports = __webpack_public_path__ + "img/dingding.874450b3.jpeg";